/**
 * Parser simple pour les données iCal
 * Parse les événements VEVENT du format iCalendar
 */

export const parseICalData = (icalString) => {
  if (!icalString) return [];

  const events = [];
  const lines = icalString.split(/\r?\n/);
  let currentEvent = null;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();

    if (line === 'BEGIN:VEVENT') {
      currentEvent = {};
    } else if (line === 'END:VEVENT' && currentEvent) {
      events.push(currentEvent);
      currentEvent = null;
    } else if (currentEvent && line.includes(':')) {
      const [key, ...valueParts] = line.split(':');
      const value = valueParts.join(':');

      if (key.startsWith('DTSTART')) {
        currentEvent.startDate = parseICalDate(value);
      } else if (key.startsWith('DTEND')) {
        currentEvent.endDate = parseICalDate(value);
      } else if (key === 'SUMMARY') {
        currentEvent.summary = value;
      } else if (key === 'DESCRIPTION') {
        currentEvent.description = value;
      } else if (key === 'STATUS') {
        currentEvent.status = value;
      } else if (key === 'UID') {
        currentEvent.uid = value;
      }
    }
  }

  return events;
};

/**
 * Parse une date au format iCal (YYYYMMDD ou YYYYMMDDTHHmmss)
 */
const parseICalDate = (dateString) => {
  if (!dateString) return null;

  // Format: YYYYMMDD ou YYYYMMDDTHHmmssZ
  const cleanDate = dateString.replace(/[^0-9]/g, '');
  
  if (cleanDate.length >= 8) {
    const year = cleanDate.substring(0, 4);
    const month = cleanDate.substring(4, 6);
    const day = cleanDate.substring(6, 8);
    
    let hour = '00';
    let minute = '00';
    let second = '00';
    
    if (cleanDate.length >= 14) {
      hour = cleanDate.substring(8, 10);
      minute = cleanDate.substring(10, 12);
      second = cleanDate.substring(12, 14);
    }
    
    return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
  }
  
  return null;
};

/**
 * Extrait les périodes réservées depuis les événements iCal
 */
export const getBookedDates = (icalString) => {
  const events = parseICalData(icalString);
  
  return events
    .filter(event => event.startDate && event.endDate)
    .map(event => ({
      start: event.startDate,
      end: event.endDate,
      summary: event.summary || 'Réservé',
      status: event.status || 'CONFIRMED'
    }))
    .sort((a, b) => a.start - b.start);
};

/**
 * Vérifie si une date est réservée
 */
export const isDateBooked = (date, bookedDates) => {
  const checkDate = new Date(date);
  checkDate.setHours(0, 0, 0, 0);
  
  return bookedDates.some(booking => {
    const start = new Date(booking.start);
    const end = new Date(booking.end);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    
    return checkDate >= start && checkDate <= end;
  });
};

/**
 * Génère une liste de mois pour affichage
 */
export const generateMonthsData = (startMonth = new Date(), numberOfMonths = 6) => {
  const months = [];
  const current = new Date(startMonth);
  current.setDate(1);
  
  for (let i = 0; i < numberOfMonths; i++) {
    months.push(new Date(current));
    current.setMonth(current.getMonth() + 1);
  }
  
  return months;
};

